import { withTranslation } from 'react-i18next';

import Header from 'components/ui/Header';
import BotList from 'components/bots/BotList';
import SectorMenu from 'components/bots/SectorMenu';
import RequestBotButton from 'components/explore/RequestBotButton';

const BotsPage = ({ t }) => {
  return (
    <>
      <Header>
        <div className="d-flex align-items-center justify-content-between flex-wrap">
          <div className="col-6 mt-2 mb-2">
            <h1 className="m-0 p-0 fw-lighter">{t('bots.title')}</h1>
          </div>

          <div className="mt-2 mb-2">
            <RequestBotButton className="btn btn-outline-light" />
          </div>
        </div>
      </Header>

      <div className="mt-5 container" id="bots-page">
        <section className="section mb-5">
          <h6 className="mb-3 text-muted">{t('bots.categories.title')}</h6>
          <SectorMenu />
        </section>

        <section className="section mb-5">
          <BotList />
        </section>
      </div>
    </>
  );
};

export default withTranslation()(BotsPage);
